import {Component, Input, OnInit, Output, EventEmitter} from "@angular/core";

@Component({
    selector: 'c-data-view-layout-options',
    templateUrl: './data-view-layout-options.component.html',
    styleUrls: ['./data-view-layout-options.component.scss']
})
export class DataViewLayoutOptionsComponent implements OnInit {

    @Input('layout') layout: string = 'grid';

    @Output('callback') callback = new EventEmitter<string>();

    ngOnInit(): void {
    }

    onClick(layout: string) {
        this.callback.emit(layout);
    }
}
